export default "__VITE_ASSET__BJPzCVZr__"